/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Roles/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'



/** @type {import('Simple/types.js').View} */
export default function Roles({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/NewAddress/Content/SearchForAddress/Content/Content/Person/Roles",
  onChange
  
}) {
let rolesValueData = fromData.useDataValue({ viewPath,
context: 'roles',
})
let personRoleValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'role',
})
let personRoleChangeData = fromData.useDataChange({ viewPath,
context: 'person',
path: 'role',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 marginLeft={dtSpaceS}
 maxWidth={180}
 data="roles"
 from={rolesValueData}
 data="person.role"
 value={personRoleValueData}
 onChange={personRoleChangeData}
>
{childProps => (
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}